const routes = [
  {
    path: '/:id?/:part?',
    name: 'EditPart',
    component: () => import('@/views/Edit.vue'),
  },
  {
    path: '/',
    redirect: '/user-management/user-enterprise-list',
  },
  {
    path: '/sign',
    name: 'Sign',
    component: () => import('@/views/Sign.vue'),
  },
  {
    path: '/analyze/:id/:part?',
    name: 'Analyze',
    component: () => import('@/views/Analyze.vue'),
  },
  {
    path: '/preview/:id/:part?',
    name: 'Preview',
    component: () => import('@/views/Preview.vue'),
  },
  {
    path: '/edit-classification/:id?',
    name: 'editClassification',
    component: () => import('@/views/EditClassification.vue'),
  },
  {
    path: '/result/:id/:part?',
    name: 'Result',
    component: () => import('@/views/Result.vue'),
  },

  {
    path: '/user-management',
    component: () => import('@/components/layouts/UserManagementLayout.vue'),
    children: [
      {
        path: 'user-enterprise-list',
        component: () => import('@/views/UserEnterpriseList.vue'),
      },
      {
        path: 'user-enterprise-list/:id',
        component: () => import('@/views/UserManagement.vue'),
      },
      {
        path: 'create-user/:id?',
        component: () => import('@/views/CreateUser.vue'),
      },
      {
        path: 'user-reply',
        component: () => import('@/views/UserReply.vue'),
      },
      {
        path: 'contact-information/:id',
        component: () => import('@/views/ContactInformation.vue'),
      },
      {
        path: 'user-group-list',
        component: () => import('@/views/UserGroupList.vue'),
      },
      {
        path: 'user-manager-list',
        component: () => import('@/views/ManagerList.vue'),
      },
      {
        path: 'edit-manager',
        component: () => import('@/views/EditManager.vue'),
      },
      {
        name: 'managerPermission',
        path: 'manager-permission',
        component: () => import('@/views/EditManagerPermission.vue'),
      },
      {
        path: 'distribute-questionnaire/:id',
        component: () => import('@/views/DistributeQuestionnaire.vue'),
      },
      {
        path: 'message-list',
        component: () => import('@/views/MessageList.vue'),
      },
      {
        path: 'email-list',
        component: () => import('@/views/EmailList.vue'),
      },
      {
        path: 'edit-email-list',
        component: () => import('@/views/EditMailList.vue'),
      },
    ],
  },

  {
    path: '/analysis-report',
    component: () => import('@/components/layouts/UserManagementLayout.vue'),
    children: [
      {
        path: 'report-enterprise-list',
        component: () => import('@/views/ReportEnterpriseList.vue'),
      },
      {
        path: '/analysis-questionnaire',
        component: () => import('@/views/AnalysisQuestionnaire.vue'),
      },
      {
        path: 'report-enterprise-list/:id',
        component: () => import('@/views/UserManagement.vue'),
      },
    ],
  },
  {
    path: '/usepc',
    component: () => import('@/views/IsMobile.vue'),
  }
]

export default routes
